import { useEffect, useRef, useState } from "react";
import printJS from "print-js";

import BusinessSuiteContentLayout from "layout/business-suite-content/BusinessSuiteContentLayout";
import { LoaderCircle, Calendar, Calculator, Send, CircleAlert } from "lucide-react";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import { useAppSelector } from "store/store";
import { AppLog } from "services";

import { useLocation } from "react-router-dom";

import InfiniteScroll from "react-infinite-scroll-component";
import { AppRecord, AppRecordStatus } from "models/appRecord";
import ImageUrl from "components/app/image-url/ImageUrl";
import { ShimmerDepartmentRender, ShimmerStaffRender } from "components/app/shrimmer/Shrimmer";
import SkeletonMusicLibrariesTable from "pages/account-detail/music-libraries/skeleton/SkeletonMusicLibrariesTable";
import { useDispatch } from "react-redux";
import { setIndexTimeSheet } from "store/header";
import { noneProfile } from "assets";
import { Snackbar } from "components";
import HoverCardDetail from "pages/hover-card-detail/HoverCardDetail";

import usePayrollAction from "./usePayrollAction";
import DailogPayroll from "../dialogStaff/DailogPayroll";
import PayrollNavbar from "./PayrollNavbar";
import PayrollDepartment from "./PayrollDepartment";
export default function Payroll() {
  //*==================Store Glogbal State===============

  //*===============Function==================

  //*===============Variable==================

  //*===============Ueffect==================

  const dataPayroll: any = usePayrollAction();
  const currentYear = new Date().getFullYear();
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const years = Array.from({ length: 100 }, (_, i) => currentYear - i);
  const [dob, setDob] = useState(new Date().toISOString().split("T")[0]); // "2025-05-05"
  const dispatch = useDispatch();
  const [searchTextInput, setSearchTextInput] = useState<string>("");
  const [selectedProductGroupCode, setSelectedProductGroupCode] = useState<string>("");
  const [view, setView] = useState("card");
  const changeView = (selectedView: string) => {
    setView(selectedView);
    localStorage.setItem("payroll", selectedView);
  };
  useState<boolean>(false);
  const { token } = useAppSelector((state) => state.auth);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");
  const selectedProductGroupCodeRef = useRef(selectedProductGroupCode);
  const [selectProducts, setSelectProducts] = useState<boolean>(false);
  const [selectedProductIds, setSelectedProductIds] = useState<string[]>([]);
  const [hovered, setHovered] = useState(false);
  const handleClickDepartment = ({ departmentName }: { departmentName: string }) => {
    if (selectedProductGroupCode === departmentName) return;
    setSelectedProductGroupCode(departmentName);
    selectedProductGroupCodeRef.current = departmentName;
  };
  const loadingProductState = {
    currentPage: 1,
    currentIndex: 0,
    nextPageUrl: "",
    totalRecord: 0,
    loadingStatus: AppRecordStatus.loading,
  };
  // -----------------------------shop Employee-------------------------------------
  const [shopEmployeePayroll, setShopEmployeePayroll] = useState<any>();
  const [shopEmployeeLoading, setShopEmployeeLoading] = useState<any>(null);
  const [shopEmployeePayrollLoadingState, setShopEmployeePayrollLoadingState] = useState<any>(null);

  const getShopEmployeePayrollSearch = async () => {
    setShopEmployeePayrollLoadingState(true);
    try {
      const url = `${RouteApi.getShopEmployeePayrollSearch}token=${token}`;
      const data = {
        shop_id: shopId,
        payroll_month: "",
        payroll_year: "",
        payroll_step: "",
        search_text: searchTextInput,
        department: selectedProductGroupCode,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setShopEmployeePayrollLoadingState(false);
        const stateRecord: AppRecord = {
          currentPage: 1,
          currentIndex: 0,
          nextPageUrl: response["employee_payrolls"]["next_page_url"] ?? "",
          totalRecord: 0,
          loadingStatus: response["employee_payrolls"]["next_page_url"] != null ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
        };
        setShopEmployeePayroll(response.employee_payrolls);

        setShopEmployeeLoading(stateRecord);
      } else {
        setShopEmployeePayrollLoadingState(false);

        console.log(response, "error fetch shop employee ");
      }
    } catch (error) {
      setShopEmployeePayrollLoadingState(false);

      AppLog.show({
        message: `[getShopEmployeeTimesheetSearch]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const fetchMoreShopEmployeePayrollSearch = async ({ next }: { next: string }) => {
    if (!next) return;

    setShopEmployeeLoading({
      ...loadingProductState,
      loadingStatus: AppRecordStatus.loadingMore,
    });

    try {
      const responses = await RequestApi(next);

      if (responses.status === "success") {
        const newEmployees = responses["employee_payrolls"]["data"];
        const nextPage = responses["employee_payrolls"]["next_page_url"];

        const updatedData = [...(shopEmployeePayroll?.data || []), ...newEmployees];

        setShopEmployeePayroll({
          ...responses["employee_payrolls"],
          data: updatedData,
        });

        setShopEmployeeLoading({
          ...loadingProductState,
          nextPageUrl: nextPage ?? "",
          loadingStatus: nextPage ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
        });
      }
    } catch (error) {
      console.error("Failed to fetch more employees:", error);
    }
  };
  const listRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (listRef.current && shopEmployeeLoading?.nextPageUrl && listRef.current.scrollHeight < window.innerHeight) {
      fetchMoreShopEmployeePayrollSearch({
        next: shopEmployeeLoading?.nextPageUrl,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopEmployeePayroll?.data]);
  useEffect(() => {
    const savedView = localStorage.getItem("payroll");
    if (savedView) {
      setView(savedView);
    }
    getShopEmployeePayrollSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTextInput, selectedProductGroupCode, dob]);

  useEffect(() => {
    dataPayroll?.getShopEmployeePayrollDepartment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // -------------------function select all ------------------
  const { indexTimeSheet } = useAppSelector((state) => state.header);
  const allIds = Array.isArray(shopEmployeePayroll?.data) ? shopEmployeePayroll?.data?.map((item: any) => item.id) : [];
  const isAllSelected = allIds.length > 0 && allIds.every((id: any) => selectedProductIds.includes(id));

  const handleToggleSelectAll = () => {
    if (isAllSelected) {
      // Deselect all
      setSelectedProductIds([]);
    } else {
      // Select all
      setSelectedProductIds(allIds);
    }
  };
  const [itemsDetail, setItemDetail] = useState<any>();
  const dataTimesheets = [
    {
      id: 1,
      title: "Recalculate",
      label: " Recalculate employee timesheets.",
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-green-500 text-white p-2 rounded-full">
          <Calculator />
        </div>
      ),
      description: [
        <>
          <p className="mb-2 font-medium text-sm text-gray-800">Recalculate totals based on the latest timesheet data and changes.</p>
          <ul className="list-disc pl-5 text-sm text-gray-700 space-y-1">
            <li>Updates total working hours, overtime, and payroll calculations.</li>
            <li>Ensures all edits (clock-ins, breaks, shifts) are accurately reflected.</li>
            <li>Run this after importing, editing, or approving timesheets.</li>
          </ul>
        </>,
      ],
    },

    {
      id: 2,
      title: "Send Report",
      label: "Send detail attendance report.",
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-blue-500 text-white p-2 rounded-full">
          <Send />
        </div>
      ),
    },
  ];
  const handleClick = (title: string) => {
    if (title === "Recalculate") {
    } else if (title === "Send Report") {
    } else {
      Snackbar({
        message: `Coming soon ${title}`,
        status: StatusMsg.warning,
      });
    }
  };
  const [loadingPrint, setLoadingPrint] = useState<boolean>(false);
  const handlePrint = async () => {
    setLoadingPrint(true);
    try {
      const url = `${dataPayroll?.storage_host_cluster_Id.host_name}/api-mobile-flipflop/v1/get-shop-employee-timesheet-report?token=${token}`;
      const data = {
        shop_id: shopId,
        working_date: dob,
        search_text: searchTextInput,
        department: selectedProductGroupCode,
        storage_host_cluster_id: dataPayroll?.storage_host_cluster_Id.id,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingPrint(false);
        const pdfUrl = response?.pdf_url;
        const pdfResponse = await fetch(pdfUrl);
        const blob = await pdfResponse.blob();
        const blobUrl = URL.createObjectURL(blob);
        printJS({ printable: blobUrl, type: "pdf" });
      } else {
        setLoadingPrint(false);

        console.log(response, "error fetch shop employee");
      }
    } catch (error) {
      setLoadingPrint(false);
      setShopEmployeePayrollLoadingState(false);

      AppLog.show({
        message: `[handlePrint]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const [dailogPayroll, setIsDailogPayroll] = useState<boolean>(false);
  // =======================new======================
  const [userShopEmployeesCalculation, setUserShopEmployeesCalculation] = useState<any>();
  const [loadingEmployeesCalcaulation, setLoadingEmployeesCalcaulation] = useState<boolean>(false);
  const getShopEmployeePayrollCalculation = async () => {
    setLoadingEmployeesCalcaulation(true);
    try {
      const url = `${RouteApi.getShopEmployeePayrollCalculation}token=${token}`;
      const data = {
        shop_id: shopId,
        payroll_month: selectedMonth + 1,
        payroll_year: selectedYear,
        payroll_step: "",
        search_text: searchTextInput,
        department: selectedProductGroupCode,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingEmployeesCalcaulation(false);
        setUserShopEmployeesCalculation(response.user_shop_employees.data);
        console.log("data===", response.user_shop_employees.data);
      } else {
        setLoadingEmployeesCalcaulation(false);

        console.log(response, "error fetch shop employee ");
      }
    } catch (error) {
      setLoadingEmployeesCalcaulation(false);

      AppLog.show({
        message: `[getShopEmployeeTimesheetSearch]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  useEffect(() => {
    if (dataPayroll?.payrollSetting) {
      dataPayroll?.setFormValues({
        payroll_pay_option: dataPayroll?.payrollSetting?.payroll_pay_option || "",
        seniority_tax_allowance: dataPayroll?.payrollSetting?.seniority_tax_allowance,
        transport_allownace: dataPayroll?.payrollSetting.transport_allownace,
        housing_allownace: dataPayroll?.payrollSetting.housing_allownace,
        phone_allownace: dataPayroll?.payrollSetting.phone_allownace,
        food_allownace: dataPayroll?.payrollSetting.food_allownace,
        other_allownace: dataPayroll?.payrollSetting.other_allownace,
        commission_pay: dataPayroll?.payrollSetting.commission_pay,
        seniority_pay: dataPayroll?.payrollSetting.seniority_pay,
        advance_pay: dataPayroll?.payrollSetting.advance_pay,
        overtime_pay: dataPayroll?.payrollSetting.overtime_pay,
        loan_deduction: dataPayroll?.payrollSetting.loan_deduction,
        advance_deduction: dataPayroll?.payrollSetting.advance_deduction,
        attendance_deduction: dataPayroll?.payrollSetting.attendance_deduction,
        other_deduction: dataPayroll?.payrollSetting.other_deduction,
        pension_deduction: dataPayroll?.payrollSetting.pension_deduction,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataPayroll?.departmentPayroll]);

  const handleInputChange = (id: string, value: any) => {
    dataPayroll?.setFormValues((prev: any) => ({ ...prev, [id]: value }));
  };
  //*===============Props==================

  const payrollNavbarProps = {
    selectProducts,
    selectedProductIds,
    allIds,
    getShopEmployeePayrollCalculation,
    setIsDailogPayroll,
    setSelectProducts,
    isAllSelected,
    handleToggleSelectAll,
    setSelectedProductIds,
    handlePrint,
    loadingPrint,
    setSearchTextInput,
    view,
    changeView,
    dataTimesheets,
    handleClick,
    selectedYear,
    setSelectedYear,
    years,
    months,
    selectedMonth,
    setSelectedMonth,
    // ✅ Correct: use key: value with optional chaining
    openPopoverSetting: dataPayroll?.openPopoverSetting,
    setOpenPopoverSetting: dataPayroll?.setOpenPopoverSetting,
    formValues: dataPayroll?.formValues,
    setFormValues: dataPayroll?.setFormValues,

    setPayrollSetting: dataPayroll?.setPayrollSetting,
    submitShopPayrollSetting: dataPayroll?.submitShopPayrollSetting,
    loadingsubmitShopPayrollSetting: dataPayroll?.loadingsubmitShopPayrollSetting,
  };
  const payrollDepartmentProps = {
    hovered,
    setHovered,
    selectedProductGroupCode,
    handleClickDepartment,
    loadingDepartmentTimeSheet: dataPayroll?.loadingDepartmentTimeSheet,
    departmentPayroll: dataPayroll?.departmentPayroll,
  };

  return (
    <BusinessSuiteContentLayout>
      {/* top bar */}
      <div className=" max-w-full z-50 w-auto bg-white sticky top-0 dark:bg-[#020817]">
        <div className={`flex ${window.innerWidth <= 1500 ? "flex-col items-start" : "flex-row  justify-between left-0 items-center "} mb-3 w-full `}>
          <div className="text-start lg:w-auto md:w-auto w-full ">
            <h1 className="font-semibold lg:text-lg md:text-md sm:text-sm">Payroll 2</h1>
            <p className=" whitespace-nowrap text-muted-foreground lg:text-md md:text-sm text-[13px]">Detailed Breakdown of Employee Earnings and Deductions. </p>
          </div>
          {dataPayroll?.warning ? "" : <PayrollNavbar {...payrollNavbarProps} />}
        </div>
        {dataPayroll?.warning ? "" : <PayrollDepartment {...payrollDepartmentProps} />}
        {/* scrollCategories */}
      </div>
      {dataPayroll?.warning ? (
        <div className="flex flex-col gap-2 items-center justify-center h-[70vh] w-full  ">
          <CircleAlert className="text-yellow-500 mx-auto w-[200px] h-[200px]" />
          <h1
            className={`text-[30px] font-semibold   ${
              dataPayroll?.errorStatus?.title === "success" || dataPayroll?.errorStatus?.title === "info"
                ? "text-green-500"
                : dataPayroll?.errorStatus?.title === "warning"
                ? "text-yellow-500"
                : "text-red-500"
            }`}
          >
            {dataPayroll?.errorStatus?.title === "success"
              ? "Success"
              : dataPayroll?.errorStatus?.title === "info"
              ? "Infomation"
              : dataPayroll?.errorStatus?.title === "warning"
              ? "Warning"
              : "Error"}
          </h1>
          <span className=" text-muted-foreground text-md pt-3 ">{dataPayroll?.errorStatus?.message}</span>
        </div>
      ) : (
        <div className="pb-3 h-full mt-5 bg-red">
          {view === "card" ? (
            <>
              {shopEmployeePayrollLoadingState ? (
                <>
                  <ShimmerStaffRender />
                </>
              ) : (
                <InfiniteScroll
                  dataLength={shopEmployeePayroll?.data?.length || 0}
                  next={() =>
                    fetchMoreShopEmployeePayrollSearch({
                      next: shopEmployeeLoading.nextPageUrl,
                    })
                  }
                  hasMore={!!shopEmployeeLoading?.nextPageUrl}
                  loader={
                    <div className="absolute bottom-2 left-0 w-full flex justify-center">
                      <LoaderCircle size={30} className="animate-spin text-yellow-400" />
                    </div>
                  }
                >
                  <>
                    <div ref={listRef} className={`grid  md:grid-cols-5 grid-cols-2 ${window.innerWidth <= 1500 ? "lg:grid-cols-6" : "lg:grid-cols-8"}  gap-y-3 gap-x-2 mb-10   `}>
                      {shopEmployeePayroll?.data?.map((item: any, index: number) => {
                        return (
                          <div
                            onClick={() => {
                              if (selectProducts) {
                                setSelectedProductIds((prev) => (prev.includes(item.id) ? prev.filter((id) => id !== item.id) : [...prev, item.id]));
                                return;
                              } else {
                                // dispatch(setIndexTimeSheet(item.id));
                              }
                            }}
                            key={index}
                            className={`group   relative z-1 w-full max-w-sm border rounded-lg  ${selectedProductIds.includes(item.id) ? " " : ""}`}
                          >
                            <div className=" w-full relative overflow-hidden aspect-square  ">
                              <ImageUrl className="rounded-t-md w-full h-full  object-cover " src={!item.picture ? noneProfile : item.picture} alt="" />
                              <div
                                className={` ${
                                  selectedProductIds.includes(item.id) ? "bg-white" : ""
                                } w-4 h-4 rounded-full flex items-center justify-center absolute left-2 top-2 text-xl  ${!selectProducts ? " hidden" : " block"}`}
                              >
                                {selectedProductIds.includes(item.id) ? (
                                  <i className=" fa-solid  fa-circle-check text-blue-500 border-2 rounded-full border-white  "></i>
                                ) : (
                                  <i className=" fa-regular fa-circle text-blue-500 border-2 border-transparent rounded-full"></i>
                                )}
                              </div>
                              <HoverCardDetail
                                title="Monthly Attendance Detail Report"
                                description={
                                  <>
                                    <p className="mb-2 font-medium text-sm dark:text-white">Generate and print detailed timesheets for employees to track hours worked.</p>
                                    <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                                      <li>Includes clock-in/out times, breaks, and total hours.</li>
                                      <li>Useful for payroll, attendance verification, and compliance.</li>
                                      <li>Customize date ranges and filters before printing.</li>
                                      <li>Export options may be available (PDF, Excel, etc.).</li>
                                    </ul>
                                  </>
                                }
                              >
                                <div
                                  onClick={() => {
                                    setItemDetail({ ...item, dob });
                                  }}
                                  className={`${
                                    selectProducts ? " hidden" : " block"
                                  } cursor-pointer group-hover:scale-110 transition-all duration-300 group-hover:opacity-100 opacity-0 w-8 h-8 flex items-center justify-center bg-green-500 text-white p-2 rounded-full absolute right-2 top-2`}
                                >
                                  <Calendar className="" />
                                </div>
                              </HoverCardDetail>
                            </div>
                            <div className={`p-4 ${indexTimeSheet === item.id ? "bg-gray-200 dark:bg-[#0e172c] rounded-b-md " : ""} `}>
                              <h5 className="text-md font-semibold line-clamp-2 overflow-hidden h-[20px] ">{item?.local_name}</h5>
                              <span className="text-sm line-clamp-1 overflow-hidden h-[20px]  ">{item?.department}</span>

                              <p className=" font-semibold line-clamp-2 text-sm text-muted-foreground h-[20px]"> {item.position}</p>
                              <div key={index} className="flex items-center justify-between">
                                <p className={`font-semibold text-sm h-[20px] ${item.in_time < item.starting_time ? "text-red-500" : "text-muted-foreground"}`}>{item.in_time} </p>
                                <p className={`font-semibold text-sm h-[20px] ${item.out_time < item.ending_time ? "text-red-500" : "text-muted-foreground"}`}>{item.out_time}</p>
                              </div>
                              <div className="flex items-center justify-between">
                                <p className={` ${!item.starting_time ? "text-red-500" : ""} font-semibold line-clamp-2 text-sm text-muted-foreground h-[20px]`}>
                                  {" "}
                                  {!item.starting_time ? "OFF" : !item.in_time ? "A" : ""}
                                </p>
                                <p className={` ${!item.ending_time ? "text-red-500" : ""} font-semibold line-clamp-2 text-sm text-muted-foreground h-[20px]`}>
                                  {" "}
                                  {!item.ending_time ? "OFF" : !item.out_time ? "A" : ""}
                                </p>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      {!shopEmployeePayroll?.next_page_url ? (
                        <p className="absolute bottom-0 left-0 w-full text-center mb-5 flex items-center justify-center">
                          <b>Nothing more to load!</b>
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                  </>
                </InfiniteScroll>
              )}
            </>
          ) : (
            <>
              {shopEmployeePayroll ? (
                <InfiniteScroll
                  dataLength={shopEmployeePayroll?.data?.length || 0}
                  next={() =>
                    fetchMoreShopEmployeePayrollSearch({
                      next: shopEmployeeLoading.nextPageUrl,
                    })
                  }
                  scrollThreshold="90%"
                  hasMore={!!shopEmployeeLoading.nextPageUrl}
                  scrollableTarget="scrollableDiv"
                  loader={
                    <div className="absolute bottom-2 left-0 w-full flex justify-center mt-5">
                      <LoaderCircle size={30} className="animate-spin text-yellow-400" />
                    </div>
                  }
                  // endMessage={
                  //   <p className="absolute bottom-0 left-0 w-full text-center mb-5 ">
                  //     <b>Nothing more to load!</b>
                  //   </p>
                  // }
                >
                  <>
                    {shopEmployeePayrollLoadingState ? (
                      <SkeletonMusicLibrariesTable />
                    ) : (
                      <table className="min-w-full border-collapse mb-20 rounded-md overflow-hidden">
                        <thead className="sticky top-0 left-0 text-xs text-gray-700  bg-gray-50 dark:bg-[#2c3a52] dark:text-gray-400">
                          <tr className="border-none text-[15px] font-bold">
                            <th className=" py-5 px-4 first:rounded-tl-md last:rounded-tr-md ">Image</th>
                            <th className="px-4 text-start ">Staff Name </th>
                            <th className="px-4">Department</th>
                            <th className="px-4">Position</th>
                            <th className="px-4">Starting Time</th>
                            <th className="px-4">Ending Time</th>
                          </tr>
                        </thead>
                        <tbody>
                          {shopEmployeePayroll?.data?.map((item: any, index: number) => {
                            return (
                              <tr
                                onClick={() => {
                                  if (selectProducts) {
                                    setSelectedProductIds((prev) => (prev.includes(item.id) ? prev.filter((id) => id !== item.id) : [...prev, item.id]));
                                    return;
                                  } else {
                                    dispatch(setIndexTimeSheet(item.id));
                                  }
                                }}
                                key={index}
                                className={`text-center group cursor-pointer ${
                                  index % 2 === 0 ? "bg-gray-100 dark:bg-[#1e293b] " : "bg-gray-200 dark:bg-[#2c3a52] "
                                } hover:bg-gray-300`}
                              >
                                <td className="relative  w-[100px] h-[100px]">
                                  <div
                                    className={` ${
                                      selectedProductIds.includes(item.id) ? "bg-white" : ""
                                    } w-4 h-4 rounded-full flex items-center z-50 justify-center absolute left-[6px] top-[6px] text-xl  ${!selectProducts ? " hidden" : " block"}`}
                                  >
                                    {selectedProductIds.includes(item.id) ? (
                                      <i className=" fa-solid  fa-circle-check text-blue-500 border-2 rounded-full border-white  "></i>
                                    ) : (
                                      <i className=" fa-regular fa-circle text-blue-500 border-2 border-transparent rounded-full"></i>
                                    )}
                                  </div>
                                  <HoverCardDetail
                                    title="Monthly Attendance Detail Report"
                                    description={
                                      <>
                                        <p className="mb-2 font-medium text-sm dark:text-white">Generate and print detailed timesheets for employees to track hours worked.</p>
                                        <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                                          <li>Includes clock-in/out times, breaks, and total hours.</li>
                                          <li>Useful for payroll, attendance verification, and compliance.</li>
                                          <li>Customize date ranges and filters before printing.</li>
                                          <li>Export options may be available (PDF, Excel, etc.).</li>
                                        </ul>
                                      </>
                                    }
                                  >
                                    <div
                                      onClick={() => {
                                        setItemDetail({ ...item, dob });
                                      }}
                                      className={`${
                                        selectProducts ? " hidden" : " block"
                                      } group-hover:scale-110 transition-all duration-300 group-hover:opacity-100 opacity-0 w-8 h-8 flex items-center justify-center bg-green-500 text-white p-2 rounded-full absolute z-50 left-[6px] top-2`}
                                    >
                                      <Calendar className="" />
                                    </div>
                                  </HoverCardDetail>

                                  <ImageUrl src={!item.picture ? noneProfile : item.picture} className="w-[100px] h-[100px] z-1 mx-auto relative" alt="" />
                                </td>
                                <td className="py-2 px-4 text-md  text-start">
                                  <p className="text-md ">{item?.local_name}</p>
                                </td>
                                <td className="py-2 px-4 text-md ">{item?.department}</td>
                                <td className="py-2 px-4 text-md ">{item.position}</td>

                                <td className="py-2 px-4 text-md font-semibold">
                                  <div key={index} className="flex flex-col items-center justify-between">
                                    <p className={`font-semibold text-sm h-[20px] ${item.in_time < item.starting_time ? "text-red-500" : "text-muted-foreground"}`}>
                                      {item.in_time}{" "}
                                    </p>
                                  </div>
                                </td>
                                <td className="py-2 px-4 text-md font-semibold">
                                  <div key={index} className="flex flex-col items-center justify-between">
                                    <p className={`font-semibold text-sm h-[20px] ${item.out_time < item.ending_time ? "text-red-500" : "text-muted-foreground"}`}>
                                      {item.out_time}
                                    </p>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                          {!shopEmployeePayroll?.next_page_url ? (
                            <p className="absolute bottom-0 left-0 w-full text-center mb-5 flex items-center justify-center">
                              <b>Nothing more to load!</b>
                            </p>
                          ) : (
                            ""
                          )}
                        </tbody>
                      </table>
                    )}
                  </>
                </InfiniteScroll>
              ) : (
                <></>
              )}
            </>
          )}
        </div>
      )}
      <DailogPayroll
        userShopEmployeesCalculation={userShopEmployeesCalculation}
        dailogPayroll={dailogPayroll}
        setIsDailogPayroll={setIsDailogPayroll}
        editItemCategories={""}
        filteredData={undefined}
        userShopShiftGroup={undefined}
        setFilteredData={undefined}
        searchTextInput={""}
        loadingEmployeesCalcaulation={loadingEmployeesCalcaulation}
      />
    </BusinessSuiteContentLayout>
  );
}
